module.exports = __webpack_public_path__ + "static/media/greenhouse2Step3-1.63dc34f4.png";